module.exports = __webpack_public_path__ + "img/gwangbok.e6b2d1d2.png";